import { AutoGraphIcon } from '@cgn/framework-ui-components/googleOutlinedIcons';
import PropTypes from 'prop-types';
import React from 'react';
import { PanelWarningIcon } from '@cgn/framework-ui-components/icons';
import { CampagnaPianiValore } from '../domain/eccellenza/eccellenza';
import PanelPianoUnicita from '../Shared/PanelPianoUnicita';

function Title({ children }) {
  return (
    <h1 className="helpdesk-frontend-card-eccellenza-piano-qualita-non-attivo__title small-text-bold">
      <PanelWarningIcon />
      {children}
    </h1>
  );
}

Title.propTypes = {
  children: PropTypes.element.isRequired,
};

Title.defaultProps = {
};

/**
*/
export default function CardPianoQualita(props) {
  return (
    <section className="helpdesk-frontend__card-piano-qualita-main">
      <section className="helpdesk-frontend__card-piano-qualita-message">
        <p className="small-text-bold">
          Come risparmire tempo?
        </p>
        <p className="small-text-regular">
          Tutti i tuoi quesiti verrebbero evasi con priorità alta se tu attivassi il Piano Eccellenza.
        </p>

        <p className="small-text-regular helpdesk-frontend__card-piano-qualita-messaggio-attiva">
          <AutoGraphIcon />Attiva il Piano Eccellenza
        </p>

        <p className=" ">
          Scopri di più sulle altre funzioni e sui&nbsp;<a href={CampagnaPianiValore} target="__blank">Piani di Valore CGN</a>
        </p>
      </section>

      <section className="helpdesk-frontend__card-piano-qualita-promozione-unicita small-text-regular">
        <PanelPianoUnicita />
      </section>
    </section>
  );
}
